import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { NavGuardProvider } from "@/context/NavGuardContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Search from "@/pages/Search";
import CaseDetail from "@/pages/CaseDetail";
import ReportForm from "@/pages/ReportForm";
import ContactForm from "@/pages/ContactForm";
import ReportAbuse from "@/pages/ReportAbuse";
import PrintCase from "@/pages/PrintCase";
import { Privacy, Terms } from "@/pages/Legal";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MyReports from "@/pages/MyReports";
import EditReport from "@/pages/EditReport";
import ChangePassword from "@/pages/ChangePassword";
import Contact from "@/pages/Contact";
import PendingReports from "@/pages/PendingReports";
import LookupReport from "@/pages/LookupReport";
import LookupRequest from "@/pages/LookupRequest";
import Admin from "@/pages/Admin";

function Protected({ children, adminOnly }) {
  const { user, isAdmin, loading } = useAuth();
  if (loading) return <div className="p-10 text-center text-[#475569]">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <NavGuardProvider>
          <Toaster position="top-center" />
          <Routes>
            <Route path="/caso/:code/imprimir" element={<Layout><PrintCase /></Layout>} />
            <Route path="/*" element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/buscar" element={<Search />} />
                  <Route path="/caso/:code" element={<CaseDetail />} />
                  <Route path="/caso/:code/contacto" element={<ContactForm />} />
                  <Route path="/caso/:code/abuso" element={<ReportAbuse />} />
                  <Route path="/reportar/desaparecida" element={<ReportForm caseType="missing" />} />
                  <Route path="/reportar/encontrada" element={<ReportForm caseType="found_alive" />} />
                  <Route path="/privacidad" element={<Privacy />} />
                  <Route path="/terminos" element={<Terms />} />
                  <Route path="/contacto" element={<Contact />} />
                  <Route path="/pendientes" element={<PendingReports />} />
                  <Route path="/consultar-reporte" element={<LookupReport />} />
                  <Route path="/consultar-solicitud" element={<LookupRequest />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/registro" element={<Register />} />
                  <Route path="/mis-reportes" element={<Protected><MyReports /></Protected>} />
                  <Route path="/mis-reportes/:id/editar" element={<Protected><EditReport /></Protected>} />
                  <Route path="/cambiar-contrasena" element={<Protected><ChangePassword /></Protected>} />
                  <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            } />
          </Routes>
          </NavGuardProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
